import { AssignedTagToSimDTO, FetchAssignedTagToSimsFilter } from 'tags/models/tagsApi.types';
import { createAsignTagApi, createTagApiService } from 'tags/utils/createTagApiService';
import { envVariables } from 'src/common/utils/envVariables';

const API_PATH = envVariables.VITE_SIM_PRODUCTS_API;
const { fetchTags, fetchTag, createTag } = createTagApiService({
  baseApiPath: API_PATH,
});

export const fetchSimProductsTags = fetchTags;
export const fetchSimProductsTag = fetchTag;
export const createSimProductsTag = createTag;

const { fetchAssignedTagsToCards, fetchAssignedTagsToCard, assignTagsToCard } = createAsignTagApi<
  FetchAssignedTagToSimsFilter,
  AssignedTagToSimDTO[]
>({
  baseApiPath: API_PATH,
  cardIdName: 'iccid',
  cardArrayIdsName: 'iccids',
});

export const assignTagsToSimProducts = assignTagsToCard;

export const fetchAssignedTagToSimProduct = fetchAssignedTagsToCard;

export const fetchAssignedTagsToSimProducts = fetchAssignedTagsToCards;
